import Vue from 'vue'
import App from './App.vue'
import router from './router/'
import store from './store/'
import mixins from './mixins/'

import './utils/index'
import './assets/scss/common/common.scss'
// plugin
import './plugins/element'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
// customer SCSS
import './assets/scss/base.scss'
import 'element-ui/lib/theme-chalk/base.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import Echarts from 'echarts'

import dayjs from "dayjs";
Vue.use(ElementUI, { locale })
Vue.prototype.$echarts = Echarts;
Vue.prototype.$dayjs = dayjs;

Vue.component(CollapseTransition.name, CollapseTransition)

Vue.config.productionTip = false
Vue.mixin(mixins)
let vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
window.vue = vue
export default vue
